import { on, selectAll, closest } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'

const selectors = {
  MODAL_SELECTOR: 'modal-dialog',
  TRIGGER_BUTTON_SELECTOR: '.js-modal-dialog-trigger'
}

const modalEls = selectAll(selectors.MODAL_SELECTOR)
const buttonEls = selectAll(selectors.TRIGGER_BUTTON_SELECTOR)

if (modalEls.length > 0 && buttonEls.length > 0) {
  buttonEls.forEach((item) => {
    on(
      'click',
      (e) => {
        const targetElement = closest(selectors.TRIGGER_BUTTON_SELECTOR, e.target)

        if (targetElement && targetElement.id) {
          modalEls.find((modal) => modal.dataset.target === targetElement.id).show()
          clearAllBodyScrollLocks()

          if (targetElement.id === 'MiniCart') {
            globalEmitter.emit(emitterProps.cart.render, true)
          }
        } else {
          modalEls.find((modal) => modal.dataset.target === e.target.id).show()

          clearAllBodyScrollLocks()
        }
      },
      item
    )
  })
}
